import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type TAppUIState } from 'features/app-ui/types';

const getInitialSidebarCollapsed = (): boolean => {
  try {
    return localStorage.getItem('compactSidebar') === 'true';
  } catch {
    return false;
  }
};

const getInitialDarkMode = (): boolean => {
  try {
    return localStorage.getItem('darkMode') === 'true';
  } catch {
    return false;
  }
};

const initialState: TAppUIState = {
  isListView: true,
  isSidebarCollapsed: getInitialSidebarCollapsed(),
  selectedMenuKeys: [],
  fullContentView: true,
  appPrimaryColor: '#053871',
  darkMode: getInitialDarkMode(),
};

const appUISlice = createSlice({
  name: 'appUI',
  initialState,
  reducers: {
    changeListView(state, action: PayloadAction<boolean>) {
      state.isListView = action.payload;
    },

    changeSidebarCollapsedState(state, action: PayloadAction<boolean>) {
      state.isSidebarCollapsed = action.payload;
      try {
        localStorage.setItem('compactSidebar', JSON.stringify(action.payload));
      } catch {
        // ignore storage errors
      }
    },

    setSelectedMenuKeys(state, action: PayloadAction<string[]>) {
      state.selectedMenuKeys = action.payload;
    },

    setDarkMode(state, action: PayloadAction<boolean>) {
      state.darkMode = action.payload;
      try {
        localStorage.setItem('darkMode', JSON.stringify(action.payload));
      } catch {
        // ignore storage errors
      }
      !action.payload
        ? document.documentElement.classList.remove('dark')
        : document.documentElement.classList.add('dark');
    },
  },
});

export const {
  changeListView,
  changeSidebarCollapsedState,
  setSelectedMenuKeys,
  setDarkMode,
} = appUISlice.actions;
export default appUISlice.reducer;
